import Webforms from "./webforms";

var $window = $(window);
var $body = $('body');
var $header = $('#header');
var $wrapper = $('#wrapper');
var spaceToHeaderFixed;
var language = $('html').attr('lang');
var timeTransitionDefault = 350;
var texts = [];

window.page = $body.data('page');

texts['pt-BR'] = {
  quantity: 'quantidade',
  price: 'preço',
  cart_empty: 'O seu carrinho está vazio',
  go_product: 'Ir para a página do produto',
  btn_edit_cart: 'Editar pedido',
  btn_checkout: 'Finalizar pedido',
  btn_success: 'Adicionado!',
  errorsTxt: {
    withoutSku: 'Selecione um atributo para o produto'
  }
};

function getText (key, subKey) {
  if (typeof subKey == 'undefined') {
    return texts[language][key];
  } else {
    return texts[language][key][subKey];
  }
}

window.store = {
  config: {
    // Seletor do botão de comprar
    selectorBtnBuy: '[data-action="add-cart"]',
    // Seletor do elemento que engloba um produto
    selectorWrapperProduct: '[data-box-produto]',
    selectorFormProduct: '[data-form-product]',
    // Se a store tem versão internacional ou não
    hasInternacionalVersion: false,
    errorsTxt: {
      withoutSku: getText('errorsTxt', 'withoutSku'),
    },
    // configuração de comportamento ao add um produto
    addToCartOpenCartpopup: true,
    addToCartOpenCartpopupMobile: true,
    cartCount: {
      selector: '[data-cart-count]',
      attr: '[data-cart-count-attr]',
      text: '[data-cart-item-text]',
      textLabel: '[data-cart-item-text-label]',
    },
    priceProds: {
      selector: '[data-update-price]',
      attr: 'update-price',
    }
  },
  setCustomizationPrice: function () {
    var totalPriceCustomizations = 0;
    var item = $("[data-appearent]");

    for (let i = 0; i < item.length; i++) {
      itemPrice = parseFloat($(item[i]).attr("data-price"));
      totalPriceCustomizations += itemPrice;
    }

    return totalPriceCustomizations;
  },
  formatMoney: function (value) {
    // FORMATA UM VALOR
    return "R$ " + value.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+\,)/g, "$1.");
  },
  validateQuantity: function (_val) {
    // VALIDA SE A QUANTIDADE INFORMADA É UM NÚMERO
    if (!isNaN(_val)) {
      if (parseInt(_val) > 0) {
        return true;
      }
    }

    return false;
  },
  getClearNumber: function (_val) {
    // RETORNA UM NÚMERO LIMPO COMO INT
    if (!isNaN(_val)) {
      clearNumber = parseInt(_val);

      return clearNumber;
    }

    return false;
  },
  validateFormProduct: function (_$form) {
    // VALIDA O FORM DE PRODUTO PARA VER SE O PRODUTO PODE SER ADICIONADO
    var $parent = _$form.closest('[data-box-produto]');
    var $btnComprar = _$form.find('[data-action="add-cart"]');
    var validated = true;
    var errorsTxt = [];

    if ($btnComprar.data('available') == 'false') {
      validated = false;
      errorsTxt.push('');
    } else {
      //  verifica se o sku foi selecionado
      if (_$form.find('[name="sku"]').val() == '') {
        validated = false;
        errorsTxt.push('Selecione um atributo para o produto');
      }

      //  verifica se a quantidade é válida
      //console.log(_$form.find('input[name="quantity"]').val());
      if (_$form.find('input[name="quantity"]').val() <= 0) {
        //console.log("qtd invalida");
        validated = false;
        errorsTxt.push('Quantidade indisponível');
      }
    }

    return {validated: validated, errors: errorsTxt};
  },
  setRespValidateProduct: function (_resp, _$form, _$boxResponse) {
    // var $boxResult = _$form.find('.resp-validate');
    var $boxResult = _$boxResponse;
    var htmlErrors = '';

    if (_resp.validated) {
      $boxResult.empty();

    } else {
      for (var i = _resp.errors.length - 1; i >= 0; i--) {
        htmlErrors += '<span class="msg error">' + _resp.errors[i] + '</span>';
      }

      $boxResult.html(htmlErrors);

      $('html,body').animate({
        scrollTop: $boxResult.offset().top + 100
      },'250');
    }
  },
  addItemResultDefault: function (_$form, _typeResult, _result, _$boxResponse) {
    var _this = this;
    if (_typeResult == 'produto-adicionado') {
      var $btnComprar = _$form.find(_this.config.selectorBtnBuy);

      //console.log("addItemResultDefault");

      $btnComprar.addClass('success').html('Produto adicionado!');

      setTimeout(function () {
        // _$form.find('.msg-response').slideUp(350);
        $btnComprar.removeClass('success').html($btnComprar.data('text-available'));
      }, 3500);

      setTimeout(function () {
        window.location.href = urlCart;
      }, 150);

    } else if (_typeResult == 'erro-adicionar') {
      var errorText = JSON.parse(_result.responseText);

      if (typeof(_$boxResponse) != 'undefined' && _$boxResponse.length > 0) {
        $('html,body').animate({
          scrollTop: _$boxResponse.offset().top
        },'250');

        //console.info(errorText);

        _$boxResponse.addClass('error');
        _$boxResponse.removeClass('success');

        _$boxResponse.find('span').html(errorText.error);
        _$boxResponse.slideDown(350);

        setTimeout(function () {
          _$boxResponse.slideUp(350);
        }, 3500);
      }
    }
  },
  addItem: async function (_$form, _$parent, addItemResult) {
    var _this = this;
    var $btnComprar = _$parent.find('[data-action="add-cart"]');
    var urlAdd = '/carrinho/adicionar';
    var urlUpdate = '/carrinho';
    var url = urlAdd;
    var $boxResponse = _$parent.find('[data-form-product] .msg-response:not(.resp-validate)');
    let form = _$form.serializeArray();




    let quantity = form.filter(field => field.name.includes('quantity'));
    quantity = quantity[0].value;

    let customizations = form.filter(field => field.name.includes('customizations'));

    for (i = 1; i < quantity; i++){
      form = form.concat(...customizations)
    }

    if (!$btnComprar.hasClass('adding')) {
      $.ajax({
        url: url,
        type: 'POST',
        dataType: 'json',
        data: form,
        beforeSend: function () {
          $btnComprar.addClass('adding');
        }
      })
      .done(function(resp) {
        //console.log("success");
        //console.info(resp);

        if (typeof addItemResult == 'function') {
          addItemResult(_$form, 'produto-adicionado', resp, $boxResponse);
        } else {
          _this.addItemResultDefault(_$form, 'produto-adicionado', resp.items_count, $boxResponse);
        }
      })
      .fail(function(resp) {
        //console.log("error");
        //console.error(resp);
        //console.error(resp.responseText);
        //console.error(resp.responseText.error);

        if (typeof addItemResult == 'function') {
          addItemResult(_$form, 'erro-adicionar', resp, $boxResponse);
        } else {
          _this.addItemResultDefault(_$form, 'erro-adicionar', resp, $boxResponse);
        }
      })
      .always(function() {
        //console.log("complete");
        $btnComprar.removeClass('adding');
      });
    }
  },
  deleteItem: function (_itemId, _$item, removeItemResult) {
    var _this = this;

    if (!_$item.hasClass('removing')) {
      $.ajax({
        url: '/carrinho',
        type: 'POST',
        dataType: 'json',
        data: {
          '_method': 'delete',
          'item_id': _itemId
        },
        beforeSend: function () {
          _$item.addClass('removing');
        }
      })
      .done(function(_cart) {
        //console.log("success");

        if (typeof removeItemResult == 'function') {
          removeItemResult(_$item, _cart);
        }
      })
      .fail(function(error) {
        //console.log("erro ao remover", error.responseText);
      })
      .always(function() {
        _$item.removeClass('removing');
      });
    }
  },
  setMsgResponse: function (_msg, _type, _$parent) {
    /*
      O tipo pode conter um dos 3 valores: success, warning, error ou CLEAR.
      O type CLEAR limpa as mensagens e faz sumir a mensagem
    */

    // Verifica se não há mais de uma mensagem
    // caso tenha, gera um html para cada mensagem
    if (Array.isArray(_msg)) {
      var msgArr = _msg;
      _msg = '';
      for (var i = msgArr.length - 1; i >= 0; i--) {
        _msg += '<span class="msg error">' + msgArr[i] + '</span>';
      }
    }

    _$parent
      .find('[data-msg-retorno]')
        .removeClass('success')
        .removeClass('warning')
        .removeClass('error');

    _$parent.find('[data-msg-retorno] [data-msg]').empty();

    if (_type != 'clear') {
      _$parent.find('[data-msg-retorno]').addClass(_type);
      _$parent.find('[data-msg-retorno] [data-msg]').html(_msg);
    }
  },
  updateCartCount: function (_itemsCount) {
    var _this = this;

    // $(_this.cartCount.selector).empty().text(_itemsCount);

    $(_this.config.cartCount.attr).data('cart-count-attr', _itemsCount);
    $(_this.config.cartCount.attr).attr('data-cart-count-attr', _itemsCount);

    $(_this.config.cartCount.attr).html(_itemsCount);
    $(_this.config.cartCount.text).html(_itemsCount);
    $(_this.config.cartCount.textLabel).html(_itemsCount > 1 ? 'itens' : 'item');

    if (_itemsCount > 0) {
      $('[data-cart-body]').parent().addClass('active');
    } else {
      $('[data-cart-body]').parent().removeClass('active');
    }

  },
  getCartCount: function () {
    async function getCartItens () {
      let itens;

      try {
        itens = await $.ajax({
          url: '/carrinho/itens',
          type: 'GET',
          dataType: 'text'
        });

        return itens;
      } catch (error) {
        //console.error(error);
      }
    }

    if ($(store.config.cartCount.selector).length > 0) {
      getCartItens().then((total) => {
        var itens = Number.isInteger(parseInt(total));
        if (itens) {
          $(store.config.cartCount.attr).attr('data-cart-count-attr', total);
          $(store.config.cartCount.selector).html(total);

          var $boxCart = $('[data-cart-body]');

          if ($boxCart.length > 0) {
            if (total > 0) {
              template_store.headerCart.loadCart(total);
            } else {
              $boxCart.html('<div class="empty"><p>Seu carrinho está vazio...</p></div>');
            }
          }
        }
      });
    };
  },
  submitForm: function (_$form, _email, _callback) {

    if (typeof _email != 'undefined' && _email != '') {
      _$form.find('[name="reply_to"]').val(_email);
    } else {
      _$form.find('[name="reply_to"]').val(_$form.find('[name="email"]').val());
    }

    if (!_$form.hasClass('sending')) {
      $.ajax({
        url: '/webform',
        type: 'POST',
        data: _$form.serialize(),
        beforeSend: function () {
          _$form.removeClass('error');
          _$form.addClass('sending');
        }
      })
      .done(function() {
        // console.info('foi');
        // store.setMsgResponse('Mensagem enviada com sucesso!', 'success', _$form);
        _$form.addClass('sended');
        _$form.find('[data-msg-retorno] [data-msg-success]').addClass('visible');
        _$form.find('[data-msg-retorno] [data-msg-error]').removeClass('visible');
        _$form.find("button[type=submit]").text('Enviado');

        setTimeout(function() {
          _$form.removeClass('sended');
          _$form.find("button[type=submit]").text('Enviar');
        }, 3500);

        _$form[0].reset();

        if (typeof _callback == 'function') {
          _callback('success');
        }
      })
      .fail(function() {
        // console.info('foi, mas deu ruim');
        _$form.addClass('error');
        _$form.find('[data-msg-retorno] [data-msg-success]').removeClass('visible');
        _$form.find('[data-msg-retorno] [data-msg-error]').addClass('visible');
        _$form.find("button[type=submit]").text('Falha ao enviar');

        setTimeout(function() {
          _$form.find("button[type=submit]").text('Enviar');
        }, 3500);

        if (typeof _callback == 'function') {
          _callback('error');
        }

        // store.setMsgResponse('Houve um problema ao enviar sua mensagem, tente novamente! Ou entre em contato conosco pelo telefone (21) 99644-6925 ', 'error', $form);
      })
      .always(function() {
        //console.log("complete");
        _$form.removeClass('sending');
      });
    }
  },
  getPriceProd: function () {
    var selector = store.config.priceProds.selector;
    var attr = store.config.priceProds.attr;

    if ($(selector).length > 0) {
      $(selector).each(function(index, value) {
        var $this = $(this);
        var prodId = $(this).data(attr);
        var url = '/produto/preco/' + prodId;

        if(prodId != '' && prodId != null) {
          $.ajax({
            url: url,
            type: 'GET',
          })
          .done(function(resp) {
            //console.info(resp);
            $this.html(resp);
          })
          .fail(function(resp) {
            //console.error(resp);
          });
        }
      });
    }
  },
  login: {
    validateLogin: function (_$form) {
      var validated = true;
      var errorsTxt = [];

      if (_$form.find('[name="email"]').val() == '') {
        validated = false;
        errorsTxt.push('Informe seu email!');
      }

      if (_$form.find('[name="password"]').val() == '') {
        validated = false;
        errorsTxt.push('Informe a senha!');
      }

      return {validated: validated, errors: errorsTxt};
    },
    validateRegister: function (_$form) {
      var validated = true;
      var errorsTxt = [];

      if (_$form.find('[name="email"]').val() == '') {
        validated = false;
        errorsTxt.push('Informe seu email!');
      }

      if (_$form.find('[name="password"]').val() == '') {
        validated = false;
        errorsTxt.push('Informe uma senha!');
      }

      if (_$form.find('[name="password"]').val() != '') {
        var pass = _$form.find('[name="password"]').val();
        var confirmationPass = _$form.find('[name="password_confirmation"]').val();

        if (pass != confirmationPass) {
          validated = false;
          errorsTxt.push('Senha e confirmação são diferentes!');
        }
      }

      return {validated: validated, errors: errorsTxt};
    },
    validateRecover: function (_$form) {
      var validated = true;
      var errorsTxt = [];

      if (_$form.find('[name="email"]').val() == '') {
        validated = false;
        errorsTxt.push('Informe seu email!');
      }

      return {validated: validated, errors: errorsTxt};
    },
    logar: function (_$form) {
      if (!_$form.hasClass('sending')) {
        $.ajax({
          url: '/entrar',
          type: 'POST',
          dataType: "json",
          data: _$form.serialize(),
          beforeSend: function () {
            _$form.addClass('sending');
          }
        })
        .done(function(resp) {
          //console.log("success", resp);

          if (resp.error) {
            store.setMsgResponse(resp.error, 'error', _$form);
          }

          if (resp.client) {
            window.location.href = resp.redirect_to;
          }
        })
        .fail(function(resp) {
          //console.error("error", error.responseText);
        })
        .always(function() {
          //console.log("complete");
          _$form.removeClass('sending');
        });
      }
    },
    recoverPassord: function (_$form) {
      if (!_$form.hasClass('sending')) {
        $.ajax({
          url: '/recuperar_senha',
          type: 'POST',
          dataType: "json",
          data: _$form.serialize(),
          beforeSend: function () {
            _$form.addClass('sending');
          }
        })
        .done(function(resp) {
          //console.log("success", resp);

          if (resp.error) {
            store.setMsgResponse(resp.error, 'error', _$form);
          }

          if (resp.ok) {
            store.setMsgResponse(resp.ok, 'success', _$form);
          }

          /*if (resp.client) {
            window.location.href = resp.redirect_to;
          }*/
        })
        .fail(function(resp) {
          //console.error("error", error.responseText);
        })
        .always(function() {
          //console.log("complete");
          _$form.removeClass('sending');
        });
      }
    },
  },
}

window.template_store = {
  setCarrosselProducts: function () {
    // Inicializa os carrosseis de produtos default
    $('[data-carrosel-produtos]').each(function(index, el) {

      // Pega a quantidade de itens que o carrossel contém
      var qtdItems = $(el).find('[data-item]').length;

      var swiperProductsCarousel = new Swiper($(el), {
        slidesPerView: 4,
        spaceBetween: 21,
        watchOverflow: true,
        breakpoints: {
          325: {
            slidesPerView: 2,
          },
          520: {
            slidesPerView: 2,
          },
          991: {
            slidesPerView: 3,
          },
          1400: {
            slidesPerView: 4,
          },
        },
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: $(el).closest('.section-carrosel-produtos').find('.swiper-button-next'),
          prevEl: $(el).closest('.section-carrosel-produtos').find('.swiper-button-prev'),
        },
      });
    });
  },
  setMenuMobile: function () {
    $("#menu-mobile").mmenu({
      slidingSubmenus: true,
      extensions: [
        "pagedim-black",
        "position-front"
      ],
      navbar: {
        add: true
      }
    },
    {
      offCanvas: {
        pageSelector: "#wrapper"
      }
    });
    var mmenu = $("#menu-mobile").data('mmenu');
    $('[data-action="open-menu-mobile"]').on('click', function(event) {
      event.preventDefault();
      if ($("#menu-mobile").hasClass('mm-opened')) {
        mmenu.close();
      } else {
        mmenu.open();
      }
    });
  },
  validateFormNewsletter: function (_$form) {
    var validated = true;
    var errorsTxt = [];

    if (_$form.find('[name="email-newsletter"]').val() == '') {
      validated = false;
      errorsTxt.push('Informe seu email!');
    }

    return { validated: validated, errors: errorsTxt };
  },
  addItemResult: function (_$form, _typeResult, _result, _$boxResponse) {
    var _this;

    if (_typeResult == 'produto-adicionado') {
      var $btnComprar = _$form.find(store.config.selectorBtnBuy);

      $btnComprar.addClass('success').html(getText(language));

      setTimeout(function () {
        // _$form.find('.msg-response').slideUp(350);
        $btnComprar.removeClass('success').html($btnComprar.data('text-available'));
      }, 3500);

      if ($body.width() > 768) {
        if (store.config.addToCartOpenCartpopup) {
          template_store.headerCart.loadCart(_result);
          template_store.headerCart.show();
          setTimeout(function () {
            window.location.href = urlCart;
          }, 150);
        } else {
          setTimeout(function () {
            window.location.href = urlCart;
          }, 150);
        }
      } else {
        if (store.config.addToCartOpenCartpopupMobile) {
          template_store.headerCart.loadCart(_result);
          template_store.headerCart.show();
          setTimeout(function () {
            window.location.href = urlCart;
          }, 150);
        } else {
          setTimeout(function () {
            window.location.href = urlCart;
          }, 150);
        }
      }

    } else if (_typeResult == 'erro-adicionar') {
      var errorText = JSON.parse(_result.responseText);

      if (typeof (_$boxResponse) != 'undefined' && _$boxResponse.length > 0) {
        $('html,body').animate({
          scrollTop: _$boxResponse.offset().top
        }, '250');

        //console.info(errorText);

        _$boxResponse.addClass('error');
        _$boxResponse.removeClass('success');

        _$boxResponse.find('span').html(errorText.error);
        _$boxResponse.slideDown(350);

        setTimeout(function () {
          _$boxResponse.slideUp(350);
        }, 3500);
      }
    }
  },
  removeItemResult: function (_$item, _cart) {
    template_store.headerCart.loadCart(_cart);
  },
  validateFormContato: function (_$form) {
    var validated = true;
    var errorsTxt = [];

    if (_$form.find('[name="email"]').val() == '') {
      validated = false;
      errorsTxt.push('Informe seu email!');
    }

    if (_$form.find('[name="nome"]').val() == '') {
      validated = false;
      errorsTxt.push('Informe seu nome');
    }

    if (_$form.find('[name="telefone"]').val() == '') {
      validated = false;
      errorsTxt.push('Informe seu nome');
    }

    if (_$form.find('[name="mensagem"]').val() == '') {
      validated = false;
      errorsTxt.push('Informe uma mensagem');
    }

    return { validated: validated, errors: errorsTxt };
  },
  submitFormNotify: function (_$form) {
    var formData = _$form.serialize();

    if (!_$form.hasClass('sending')) {
      $.ajax({
        url: _$form.attr('action'),
        type: 'post',
        dataType: 'json',
        data: formData,
        beforeSend: function () {
          _$form.addClass('sending');
        }
      })
        .done(function (resp) {
          //console.log("success");
          //console.info(resp);

          var msgSuccess = 'Você receberá um e-mail quando o produto estiver disponível';

          // Envia um email para o cliente saber que o usuário solicitou o avise-me
          $.ajax({
            url: '/webform',
            type: 'POST',
            data: {
              key: _$form.find('[name="key"]').val(),
              reply_to: _$form.find('[name="email"]').val(),
              email: _$form.find('[name="email"]').val(),
              product_name: _$form.find('[name="nome"]').val(),
              referencia: _$form.find('[name="referencia"]').val(),
              sku: _$form.find('[name="sku"]').val(),
            },
          })
          .done(function (resp) {
            _$form.find("button[type=submit]").text("Enviado");
            setTimeout(function () {
              _$form.find("button[type=submit]").text("Enviar");
            }, 3500);
            _$form[0].reset();
          })
          .fail(function (error) {
            _$form.find("button[type=submit]").text("Falha ao enviar");
            setTimeout(function () {
              _$form.find("button[type=submit]").text("Enviar");
            }, 3500);
          })
          .always(function () {
          })

          if (resp.error) {
            _$form.find('.msg-response').removeClass('happy').addClass('error');
            _$form.find('.msg-response span').html(resp.error);
            _$form.find('.msg-response').slideDown(350);

            setTimeout(function () {
              _$form.find('.msg-response').removeClass('happy').removeClass('error');
              _$form.find('.msg-response span').empty();
            }, 3500);

          } else {
            _$form.find('.msg-response').addClass('happy').removeClass('error');
            _$form.find('.msg-response span').html(msgSuccess);

            setTimeout(function () {
              _$form.find('.msg-response').removeClass('happy').removeClass('error');
              _$form.find('.msg-response span').empty();
            }, 3500);

          }
        })
        .fail(function (resp) {
          //console.log("error");
          //console.error(resp);
          //console.error(resp.responseText);
          //console.error(resp.responseText.error);

          var errorText = JSON.parse(resp.responseText);
          //console.info(errorText);

          _$form.find('.msg-response').removeClass('happy');
          _$form.find('.msg-response span').html(errorText.error);
          _$form.find('.msg-response').slideDown(350);

          setTimeout(function () {
            _$form.find('.msg-response').slideUp(350);
          }, 3500);
        })
        .always(function () {
          _$form.removeClass('sending');
        });
    }
  },
  headerCart: {
    loadCart: function (total) {
      var _this = this;
      var $boxCart = $('[data-cart-body]');

      store.updateCartCount(total);

      vnda.loadCartPopup(function(html) {
        $boxCart.empty();
        $boxCart.append(html);
      });
    },
    show: function () {
      var $boxCart = $('[data-cart-body]');

      $("html, body").animate({ scrollTop: 0 }, "slow");

      $boxCart.fadeIn(500, function() {
        $boxCart.addClass('active');
      });

      setTimeout(function () {
        $boxCart.fadeOut(500, function() {
          $boxCart.removeClass('active');
        });
      }, 5000);
    },
  },
  popup: {
    closePopup: function (_popup) {
      $('[data-popup="' + _popup + '"]').removeClass('active');
    },
    togglePopup: function (_popup) {
      $('.active[data-popup]').removeClass('active');

      if (_popup != '') {
        if ($('.active[data-popup]').length > 0) {
          setTimeout(function () {
            $('[data-popup="' + _popup + '"]').addClass('active');
          }, 350);
        } else {
          $('[data-popup="' + _popup + '"]').addClass('active');
        }
      }
    },
    init: function () {
      var _this = this;
      $(document).on('click', '[data-action="open-popup"]', function (event) {
        event.preventDefault();
        //console.info('event open-opopup');
        var popup = $(this).data('popup');
        _this.togglePopup(popup);
      });


      $(document).on('click', '[data-action="close-popup"]', function (event) {
        event.preventDefault();
        //console.info('event close-opopup');
        var popup = $(this).data('popup');
        _this.closePopup(popup);
      });

      $('[data-trigger-popup="cart"]').on('click', function(event) {
        event.preventDefault();

        if( !$('[data-popup="cart"]').hasClass('active') ) {
          $('[data-popup="cart"]').fadeOut();
          $('[data-popup="cart"]').removeClass('active');
        }

        if ( $(this).parent().data('cart-count-attr') > 0 ) {

          $('[data-popup="cart"]').fadeToggle();
          $('[data-popup="cart"]').toggleClass('active');

        } else {
          window.location.href = urlCart;
        }
      });

      $(document).on('click', function(event) {
        if ( !$(event.target).closest("[data-popup]").length ) {
          var popup = $("body").find(".popup.active");

          popup.fadeOut(500, function() {
            popup.removeClass('active');
          });
        }
      });
    }
  },
  home: {
    setFullbanner: function () {
      $('[data-fullbanner]').each(function (index, el) {
        var $el = $(el);

        var swiper = new Swiper($el.find('.swiper-container'), {
          slidesPerView: 1,
          spaceBetween: 0,
          watchOverflow: true,
          speed: 1000,
          autoplay: {
            delay: 4000,
          },
          navigation: {
            nextEl: $(el).find('.swiper-button-next'),
            prevEl: $(el).find('.swiper-button-prev'),
            disabledClass: '-disabled'
          },
          pagination: {
            el: $(el).find('.swiper-pagination'),
            type: 'bullets',
            clickable: true
          },
        });
      });
    },
    setBannersCategories: function () {
      $('[data-banner-categories]').each(function (index, el) {
        var $el = $(el);

        var swiper = new Swiper($el.find('.swiper-container'), {
          slidesPerView: 3,
          spaceBetween: 20,
          draggable: true,
          watchOverflow: true,
          navigation: {
            nextEl: $(el).find('.swiper-button-next'),
            prevEl: $(el).find('.swiper-button-prev'),
            disabledClass: '-disabled'
          },
          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            480: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            640: {
              slidesPerView: 2,
            },
            769: {
              slidesPerView: 3,
            }
          }
        });
      });
    },
    init: function () {
      var _this = this;
      _this.setFullbanner();
      _this.setBannersCategories();
    }
  },
  product: {
    $sectionProduct: $('[data-section-product]'),
    $wrapperImages: $('[data-section-product]').find('[data-product-images]'),
    $sliderProduct: $('[data-section-product]').find('[data-product-images] [data-main-slider]'),
    $thumbsProduct: $('[data-section-product]').find('[data-product-images] [data-slider-thumbs]'),
    sliderProduct: [],
    /*
      Exibe as primeiras imagens do produto
      ** Importante para quando houver imagem por sku **
    */
    showFirstImages: function () {
      var _this = this;
      var variants = vnda.variants.all();
      var $imagesWithoutSkus = _this.$sliderProduct.find('.image-without-sku');
      var $thumbsWithoutSkus = _this.$thumbsProduct.find('.image-without-sku');

        /*
          Percorre todas as variantes
        */
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].main) {
            console.info('oii', variants[i]);

            // Procura a imagem que contém o sku e a exibe
            _this.$sliderProduct.find('[data-image][data-skus-image*="' + variants[i].sku + '"]')
              .addClass('active')
              .removeClass('inactive');

            _this.$thumbsProduct.find('[data-image-thumb][data-skus-image*="' + variants[i].sku + '"]')
              .addClass('active')
              .removeClass('inactive');
          }
        }
        /*
          Todas as imagens sem skus são exibidas sempre
        */

        $imagesWithoutSkus
          .removeClass('inactive')
          .addClass('active');

        $thumbsWithoutSkus
          .removeClass('inactive')
          .addClass('active');

    },
    submitNotify: function () {
      $(document).on('submit', '[data-form-notify]', function (event) {
        event.preventDefault();
        template_store.submitFormNotify($(this));
      });
    },
    setGallery: function () {
      var _this = this;
      var qtdImages = _this.$sliderProduct.find('[data-image]').length;

      if (qtdImages <= 1) {
        _this.$wrapperImages.addClass('without-thumbs');
      } else {
        _this.$wrapperImages.removeClass('without-thumbs');
      }

      var gallery = new Swiper(_this.$sliderProduct, {
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,
        simulateTouch: false,
        navigation: {
          nextEl: _this.$sliderProduct.parent().find('.button-next'),
          prevEl: _this.$sliderProduct.parent().find('.button-prev'),
        },
      });

      var galleryThumbs = new Swiper(_this.$thumbsProduct, {
        spaceBetween: 10,
        slidesPerView: 4,
        // freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        simulateTouch: true,
        watchOverflow: true,
        direction: 'vertical',
        navigation: {
          nextEl: _this.$thumbsProduct.siblings('.swiper-button-next'),
          prevEl: _this.$thumbsProduct.siblings('.swiper-button-prev'),
        },
      })
      gallery.controller.control = galleryThumbs;
      galleryThumbs.controller.control = gallery;

      this.sliderProduct.push(gallery);

      $('[data-image-thumb]').on('click', function () {
        //console.log('oie');
        //console.log($(this).data('index'));
        gallery.slideTo($(this).data('index'));
      });
    },
    setQuantityProduct: function () {
      var quantityInput = document.querySelectorAll('[data-quantity-selector]');

      if (quantityInput) {
        $(document).on('click', '[data-quantity-selector] [data-plus-quantity]', function () {
          var $box = $(this).closest('[data-quantity-selector]');
          var $input = $box.find('input[name="quantity"]');
          var val = $input.val();
          var checkCustomization = $('[data-section-product] .product-infos').find('.customizations');

          if (store.validateQuantity(val)) {
            var clearNumber = store.getClearNumber(val);
            $input.val(parseInt(clearNumber) + 1);
          }
          if (checkCustomization.children()){
            window.customizations.addNode();
            console.log('é personalizado');
          } else {
            console.log('não é personalizado');
          }
        });

        $(document).on('click', '[data-quantity-selector] [data-minus-quantity]', function () {
          var $box = $(this).closest('[data-quantity-selector]');
          var $input = $box.find('input[name="quantity"]');
          var val = $input.val();
          var checkCustomization = $('[data-section-product] .product-infos').find('.customizations');

          if (store.validateQuantity(val)) {
            var clearNumber = store.getClearNumber(val);
            if ((parseInt(clearNumber) - 1) > 0) {
              $input.val(parseInt(clearNumber) - 1);
            }
          }
          if (checkCustomization.children()){
            window.customizations.removeNode();
            console.log('é personalizado');
          } else {
            console.log('não é personalizado');
          }
        });
      }
    },
    setTabs: function() {

      var FirstTabHead = $(".tabs-header .tab")[0];
      var FirstTabContent = $(".tabs-content .tab")[0];

      $(FirstTabHead).addClass("open");
      $(FirstTabContent).addClass("open");

      $(".tabs-header .tab").on("click", function(){
        var tabID = this.classList[1];
        var tabContent = $(".tabs-content").find("."+tabID)

        $(".tabs-header .tab").removeClass("open");
        $(".tabs-content .tab").removeClass("open");
        $(this).addClass("open");
        $(tabContent).addClass("open");
      })
    },
    init: function () {
      var _this = this;

      _this.showFirstImages();
      _this.setGallery();
      _this.setQuantityProduct();
      _this.submitNotify();
      _this.setTabs();




      $(document).on('submit', store.config.selectorFormProduct, function (event) {
        event.preventDefault();
        var $form = $(this);

        var blockAddToCart = $(".add-to-cart-button").hasClass("select-a-customization")

          $(".customizations label").on("click", function(){
            blockAddToCart = $body.find(".add-to-cart-button").hasClass("select-a-customization");
            if(blockAddToCart == false){
              $(".customization-notify").hide()
            } else {
              return
            }
          })

          if(blockAddToCart){
            $(".customization-notify").show()
          }else{
            var $parent = $form.closest(store.config.selectorWrapperProduct);

            var $btnComprar = $parent.find(store.config.selectorBtnBuy);

            var respValidated = store.validateFormProduct($form);
            var $boxResponse = $parent.find('.msg-response');

            if (respValidated.validated) {
              store.addItem($form, $parent);
            } else {
              //console.info('não foi');
              store.setRespValidateProduct(respValidated, $form, $boxResponse);
            }
          }
      });

    }
  },
  tag:{
    setFilterbtn: function(){
      /*$(".filtro .filter-head").on("click", function(){
        var container = this.closest('.filtro');
        var list = $(container).find(".filter-list");

        $(list).slideToggle();

        $(this).find(".plus").toggleClass("show");
        $(this).find(".minus").toggleClass("show");
      });*/

      $('.filtro .filter-head').on('click',function(){
          if ($(this).parent().hasClass('is-open')){
              $(this).parent().removeClass('is-open');
          }else{
              $(this).parent().addClass('is-open');
          }
      });
    },

    setFilterMobile: function(){
      $("#filtros .filters-title").on("click", function(){
        $("#filtros .wrapper").slideToggle()

        $(this).find(".plus").toggleClass("show")
        $(this).find(".minus").toggleClass("show")
      })
    },

    setFilterSelected:function(){
      var sPageURL = decodeURI(window.location.search.substring(1)),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;

      for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        //console.log('nome do parametro', sParameterName[0])
        //console.log('valor do parametro', sParameterName[1])

        if($('#filtros [name="' + sParameterName[0] + '"][value="' + sParameterName[1] + '"]').length > 0){
          //console.log('achou')
          $('#filtros [name="' + sParameterName[0] + '"][value="' + sParameterName[1] + '"]').closest('li').addClass('selected')
          $('#filtros [name="' + sParameterName[0] + '"][value="' + sParameterName[1] + '"]').attr('checked', true)
        }
      }
    },

    init: function(){
      template_store.tag.setFilterbtn();
      template_store.tag.setFilterMobile();
      template_store.tag.setFilterSelected();
    }
  },
  login: {
    init: function () {

      $('[data-content-login]').each(function (index, el) {
        // Animação
        $(el).on('click', '[data-forget-password]', function (event) {
          event.preventDefault();
          $(el).find('.wrapper-form-login').animate({ height: 'toggle' }, 500);
          $(el).find('.wrapper-form-recover').animate({ height: 'toggle' }, 500);
        });

        $(el).on('click', '[data-forget-password-back]', function (event) {
          event.preventDefault();
          $(el).find('.wrapper-form-login').animate({ height: 'toggle' }, 500);
          $(el).find('.wrapper-form-recover').animate({ height: 'toggle' }, 500);
        });

        $(el).on('submit', '[data-form-login]', function (event) {
          event.preventDefault();

          var $form = $(this);
          var respValidated = store.login.validateLogin($form);

          if (respValidated.validated) {
            store.login.logar($form);
          } else {
            store.setMsgResponse(respValidated.errors, 'error', $(this));
          }
        });

        $(el).on('submit', '[data-form-register]', function (event) {
          event.preventDefault();

          var $form = $(this);
          var respValidated = store.login.validateRegister($form);

          if (respValidated.validated) {
            store.login.logar($form);
          } else {
            store.setMsgResponse(respValidated.errors, 'error', $(this));
          }
        });

        $(el).on('submit', '[data-form-recover]', function (event) {
          event.preventDefault();

          var $form = $(this);
          var respValidated = store.login.validateRecover($form);

          if (respValidated.validated) {
            store.login.recoverPassord($form);
          } else {
            store.setMsgResponse(respValidated.errors, 'error', $(this));
          }
        });
      });
    }
  },
  init: function () {
    var _this = this;

    _this.popup.init();

    _this.setMenuMobile();
    _this.setCarrosselProducts();
    store.getCartCount();
    store.getPriceProd();

    $('[data-label-input]').on('focus', 'input, textarea, select', function () {
      var $field = $(this).closest('[data-label-input]');
      var $label = $field.find('label');

      $label.addClass('on-focus');
    });

    $('[data-label-input]').on('blur', 'input, textarea, select', function () {
      var $field = $(this).closest('[data-label-input]');
      var $label = $field.find('label');

      $label.removeClass('on-focus');
    });

    $('[data-label-input]').on('change', 'input, textarea, select', function () {
      var $field = $(this).closest('[data-label-input]');
      var $label = $field.find('label');

      $field.removeClass('invalid');
      $field.removeClass('valid');

      if ($(this).val() != '') {
        $label.addClass('not-empty');
      } else {
        $label.removeClass('not-empty');
      }
    });

    Webforms.init();

    // $('[data-webform]').on('submit', function (event) {
    //   event.preventDefault();

    //   var honeyPot = $(this).find('[name="vnda"]');

    //   if (honeyPot.length > 0) {
    //     if (honeyPot.val() != '') {
    //       //console.info('ROBOT DETECTED');
    //       return false;
    //     }
    //   }

    //   if ($(this).data('webform') == 'contato') {
    //     var respValidated = _this.validateFormContato($(this));
    //     var htmlErrors = '';

    //     //console.info('FORM DE CONTATO', respValidated);

    //     if (respValidated.validated) {
    //       store.submitForm($(this), false, function () {
    //         store.setMsgResponse(false, 'clear', $(this));
    //       });
    //     } else {
    //       store.setMsgResponse(respValidated.errors, 'error', $(this));
    //     }

    //   } else if ($(this).data('webform') == 'newsletter') {
    //     var respValidated = _this.validateFormNewsletter($(this));
    //     var htmlErrors = '';

    //     //console.info('FORM DE NEWSLETTER', respValidated);

    //     if (respValidated.validated) {
    //       store.submitForm($(this), false, function () {
    //         store.setMsgResponse(false, 'clear', $(this));
    //         showPromoCode();
    //       });
    //     } else {
    //       store.setMsgResponse(respValidated.errors, 'error', $(this));
    //     }

    //   } else {
    //     store.submitForm($(this));
    //   }
    // });

  }
}

$(function (){
  template_store.init();

  if (page == 'home') {
    template_store.home.init();
  }

  if (page == 'product') {
    template_store.product.init();
    setTimeout(() => {
      if (window.performance.navigation.type == 2 ) {
        window.location.reload();
      }
    }, 0);
 }

  if (page == 'tag') {
    template_store.tag.init();
  }

  if (page == 'login') {
    template_store.login.init();
  }
});


console.log('%c V' + '%cnda ' + '%c- Tecnologia em e-commerce', 'color: #b24c19; font-size: 45px;', 'color: #f88d5b; font-size: 45px;', 'color: #000; font-size: 25px;');

